import React, { Component, Fragment } from 'react';
import Select from 'react-select';
import swal from 'sweetalert';
import DosenDTB from '../../../config/perwalianDTB/dosenDTB';
import MahasiswaDTB from '../../../config/perwalianDTB/mahasiswaDTB';
import { dataDosen } from '../../../dummy-data/dosen';
import { dataMahasiswa, dropdownAngkatan } from '../../../dummy-data/mahasiswa';
import { dataProdi } from '../../../dummy-data/prodi';

const $ = require("jquery");
$.Datatable = require("datatables.net");

// styling react-select
const stylesSelect = {
    option: (provided) => ({
        ...provided,
        color: 'black'
    }),
    control: styles => ({
        ...styles,
        height: 46,
        minHeight: 46,
    }),
};

class Perwalian extends Component {

    state = {
        // search anak wali
        selectedDosen: '',
        kodeDosen: '',
        // list data anak wali
        listAnakWali: [],
        listDosen: [],
        listAngkatan: [],
        statusWali: '',
        // list data mahasiswa
        listSiswa: [],
        listProdi: [],
        // search mahasiswa
        prodi: '',
        thn_angkatan: '',
        isLoading: false
    };

    // get data dosen for select dosen
    getDosen = () => {
        const dosenList = dataDosen.map(d => ({
            idd: d.dosen_id,
            nmd: d.nama
        }));
        this.setState({
            listDosen: dosenList,
            statusData: 200,
            isLoading: false
        });
    }

    // get data prodi for select prodi
    getProdi = () => {
        const prodiList = dataProdi.map(p => ({
            ijur: p.prodi_id,
            nmjur: p.prodi_nama
        }));
        this.setState({ listProdi: prodiList });

        setTimeout(() => {
            if (document.getElementById("prodi") != null) {
                document.getElementById("prodi").disabled = false;
            }
            if (document.getElementById("loaderProdi") != null) {
                document.getElementById("loaderProdi").classList.add("sembunyi");
            }
        }, 200);
    }

    // get data angkatan for select angkatan
    getAngkatan = () => {
        const angkatanList = dropdownAngkatan.map(a => ({
            idtj: a.value,
            ketj: a.label
        }));
        this.setState({ listAngkatan: angkatanList });

        setTimeout(() => {
            if (document.getElementById("angkatan") != null) {
                document.getElementById("angkatan").disabled = false;
            }
            if (document.getElementById("loaderAngkatan") != null) {
                document.getElementById("loaderAngkatan").classList.add("sembunyi");
            }
        }, 200);
    }

    // handle search select dosen
    changeSearch = selectedDosen => {
        this.setState({
            selectedDosen,
            kodeDosen: selectedDosen.value,
        },
            this.SearchAnakWali,
        )
    };

    // cari data mahasiswa anak wali
    SearchAnakWali = () => {
        $('#dosenDTB').DataTable().destroy();
        if (this.state.kodeDosen != "") {
            document.getElementById("loaderWali").style.display = "block";
            var waliNoData = document.getElementById("waliNoData");
            if (waliNoData != null) { waliNoData.style.display = "none" }
            var waliTabel = document.getElementById("waliTabel");
            if (waliTabel != null) { waliTabel.style.display = "none" };

            // Filter mahasiswa yang sudah punya dosen wali ini
            const anakWali = dataMahasiswa
                .filter(m => m.dosen_wali_id === this.state.kodeDosen)
                .map(m => ({
                    icm: m.mhs_id,
                    nimw: m.nim,
                    nmmw: m.nama
                }));

            setTimeout(() => {
                this.setState({
                    listAnakWali: anakWali,
                    statusWali: 200
                });
                DosenDTB();
                document.getElementById("loaderWali").style.display = "none";
                var waliTabel = document.getElementById("waliTabel");
                if (waliTabel != null) { waliTabel.style.display = "block" };
            }, 300);
        }
    }

    // cari data mahasiswa
    SearchMhsClick = (event) => {
        event.preventDefault();
        this.SearchMahasiswa()
    }

    SearchMahasiswa = () => {
        if (this.state.kodeDosen != "") {
            $('#mahasiswaDTB').DataTable().destroy();
            document.getElementById("btn-cari-mhs").disabled = true
            document.getElementById("loaderMhs").style.display = "block";
            var mhsNoData = document.getElementById("mhsNoData");
            if (mhsNoData != null) { mhsNoData.style.display = "none" };
            var mhsTabel = document.getElementById("mhsTabel");
            if (mhsTabel != null) { mhsTabel.style.display = "none" };

            // Filter mahasiswa berdasarkan prodi dan angkatan yang belum punya wali ini
            let filtered = dataMahasiswa.filter(m => m.dosen_wali_id !== this.state.kodeDosen);

            if (this.state.prodi) {
                filtered = filtered.filter(m => m.prodi_id === parseInt(this.state.prodi));
            }
            if (this.state.thn_angkatan) {
                filtered = filtered.filter(m => m.angkatan === parseInt(this.state.thn_angkatan));
            }

            const siswaList = filtered.map(m => ({
                icm: m.mhs_id,
                nim: m.nim,
                nmmw: m.nama
            }));

            setTimeout(() => {
                this.setState({ listSiswa: siswaList });
                MahasiswaDTB();
                document.getElementById("btn-cari-mhs").disabled = false;
                document.getElementById("loaderMhs").style.display = "none";
                var mhsTabel = document.getElementById("mhsTabel");
                if (mhsTabel != null) { mhsTabel.style.display = "block" };
            }, 300);
        } else {
            swal({
                icon: "info",
                title: "Pilih dosen dahulu",
                text: "pilih dosen dahulu untuk menampilkan mahasiswa",
            });
        }
    }

    // handle untuk perubahan value input by name
    InputChange = (event) => {
        event.preventDefault();
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    // handle hapus anak wali dari list dosen
    HapusAnakWali = (nim) => {
        var btn = document.getElementById("hapus" + nim);
        btn.disabled = true;
        btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

        setTimeout(() => {
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Mahasiswa berhasil dihapus dari perwalian (simulasi)',
                timer: 1500,
                buttons: false
            });
            this.SearchAnakWali();
            this.SearchMahasiswa();
            $('#dosenDTB').DataTable().destroy();
            $('#mahasiswaDTB').DataTable().destroy();
            btn.disabled = false;
            btn.innerHTML = '<i class="ti-back-right btn-icon-append"></i>';
        }, 500);
    }

    // tambah anak wali dari data mahasiswa ke list dosen
    TambahAnakWali = (nim) => {
        var btn = document.getElementById("add" + nim);
        btn.disabled = true;
        btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

        setTimeout(() => {
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Mahasiswa berhasil ditambahkan ke perwalian (simulasi)',
                timer: 1500,
                buttons: false
            });
            this.SearchAnakWali();
            this.SearchMahasiswa();
            $('#dosenDTB').DataTable().destroy();
            $('#mahasiswaDTB').DataTable().destroy();
            btn.disabled = false;
            btn.innerHTML = '<i class="ti-back-left btn-icon-append"></i>';
        }, 500);
    }

    parserText = (val) => {
        var txt = document.createElement("textarea");
        txt.innerHTML = val;
        return txt.value;
    }

    componentDidMount = () => {
        this.getDosen();
        this.getProdi();
        this.getAngkatan();
        DosenDTB();
        MahasiswaDTB();
    }

    render() {

        let options = this.state.listDosen.map(function (dosen) {
            return { value: dosen.idd, label: dosen.nmd };
        })

        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Dosen&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Dosen Perwalian
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row smooth">
                    <div className="col-md-12 mb-3">
                        <div className="card card-custom">
                            <p className="card-title text-center"
                                style={{ fontSize: '25px', marginTop: '10px', paddingTop: '15px', paddingBottom: '10px' }}>
                                Dosen Perwalian
                            </p>
                        </div>
                    </div>

                    {/* anak wali  */}
                    <div className="col-md-6 mb-3">
                        <div className="card card-custom">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="form-group">
                                            <Select
                                                value={this.state.selectedDosen}
                                                onChange={this.changeSearch}
                                                options={options}
                                                styles={stylesSelect}
                                                placeholder="cari nama dosen wali"
                                                id="selectDosen"
                                                isLoading={this.state.isLoading}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-12 mb-1" style={{ marginTop: '-10px' }}>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <p
                                                    style={{ fontSize: '20px', padding: '10px 0' }}>
                                                    Dosen Wali :
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="loaderWali" style={{ display: 'none' }}>
                                    <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                        <div className="dot" />
                                        <div className="dot" />
                                        <div className="dot" />
                                    </div>
                                </div>

                                <div className="table-responsive" id="waliTabel">
                                    <table id="dosenDTB" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>NIM</th>
                                                <th>Nama mahasiswa</th>
                                                <th>Aksi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.listAnakWali.map((mhs, index) => {
                                                    return (
                                                        <tr className="dark" key={index}>
                                                            <td>{mhs.nimw}</td>
                                                            <td>{mhs.nmmw}</td>
                                                            <td>
                                                                <button
                                                                    id={"hapus" + mhs.icm}
                                                                    onClick={() => this.HapusAnakWali(mhs.icm)}
                                                                    className="btn btn-hapus2  ml-2 mt-1"
                                                                    title="kembalikan data"
                                                                    style={{ padding: '10px 15px 10px 15px' }}>
                                                                    <i className="ti-back-right btn-icon-append" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div >
                    </div>

                    {/* mahasiswa  */}
                    <div className="col-md-6">
                        <div className="card card-custom">
                            <div className="card-body">
                                <form onSubmit={this.SearchMhsClick}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <div id="loaderProdi" className="loaderInput">
                                                            <p align="right">
                                                                <i className="fa fa-spinner fa-spin"></i>
                                                            </p>
                                                        </div>
                                                        <select className="form-control" name="prodi" required
                                                            placeholder="prodi" onChange={this.InputChange} id="prodi" disabled>
                                                            <option value="">- pilih prodi -</option>
                                                            {
                                                                this.state.listProdi.map((prodi, index) => {
                                                                    return (
                                                                        <option key={index} value={prodi.ijur}>
                                                                            {prodi.nmjur}
                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <div id="loaderAngkatan" className="loaderInput">
                                                            <p align="right">
                                                                <i className="fa fa-spinner fa-spin"></i>
                                                            </p>
                                                        </div>
                                                        <select className="form-control" name="thn_angkatan" required
                                                            placeholder="prodi" onChange={this.InputChange} id="angkatan" disabled>
                                                            <option value="">- pilih angkatan -</option>
                                                            {
                                                                this.state.listAngkatan.map((angkatan, index) => {
                                                                    return (
                                                                        <option key={index} value={angkatan.idtj}>
                                                                            {angkatan.ketj}
                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12 mb-1" style={{ marginTop: '-10px' }}>
                                            <div className="row">
                                                <div className="col-sm-6 order-md-2">
                                                    <p align="right">
                                                        <button id="btn-cari-mhs" className="btn btn-success"
                                                            type="submit"
                                                            style={{ borderRadius: '5px' }}
                                                        >
                                                            cari data
                                                        </button>
                                                    </p>
                                                </div>
                                                <div className="col-sm-6">
                                                    <p
                                                        style={{ fontSize: '20px', padding: '10px 0' }}>
                                                        List Mahasiswa :
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div id="loaderMhs" style={{ display: 'none' }}>
                                        <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                            <div className="dot" />
                                            <div className="dot" />
                                            <div className="dot" />
                                        </div>
                                    </div>
                                </form>
                                <div className="table-responsive" id="mhsTabel">
                                    <table id="mahasiswaDTB" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>NIM</th>
                                                <th>Nama mahasiswa</th>
                                                <th>Aksi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.listSiswa.map((mhs, index) => {
                                                    return (
                                                        <tr className="dark" key={index}>
                                                            <td>{mhs.nim}</td>
                                                            <td>{this.parserText(mhs.nmmw)}</td>
                                                            <td>
                                                                <button
                                                                    id={"add" + mhs.icm}
                                                                    onClick={() => this.TambahAnakWali(mhs.icm)}
                                                                    className="btn btn-add2  ml-2 mt-1"
                                                                    title="masukkan data"
                                                                    style={{ padding: '10px 15px 10px 15px' }}>
                                                                    <i className="ti-back-left btn-icon-append" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div >
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Perwalian;
